import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
export function cn() {
    var inputs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        inputs[_i] = arguments[_i];
    }
    // Filter out undefined and null values
    var filteredInputs = inputs.filter(function (input) { return input !== undefined && input !== null; });
    return twMerge(clsx(filteredInputs));
}
export function formatBytes(bytes, opts) {
    var _a, _b;
    if (opts === void 0) { opts = {}; }
    var _c = opts.decimals, decimals = _c === void 0 ? 0 : _c, _d = opts.sizeType, sizeType = _d === void 0 ? "normal" : _d;
    var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    var accurateSizes = ["Bytes", "KiB", "MiB", "GiB", "TiB"];
    if (bytes === 0)
        return "0 Byte";
    var i = Math.floor(Math.log(bytes) / Math.log(1024));
    return "".concat((bytes / Math.pow(1024, i)).toFixed(decimals), " ").concat(sizeType === "accurate" ? ((_a = accurateSizes[i]) !== null && _a !== void 0 ? _a : "Bytest") : ((_b = sizes[i]) !== null && _b !== void 0 ? _b : "Bytes"));
}
